<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p class="dialog-message">{{ data.message }}</p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ data.remarksLabel || 'Comment' }}</mat-label>
    <textarea
      matInput
      [(ngModel)]="remarks"
      rows="3"
      [required]="!!data.remarksRequired"
    ></textarea>
    <mat-error *ngIf="data.remarksRequired && !remarks.trim()">This field is required</mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="undefined">Cancel</button>
  <button
    mat-raised-button
    [color]="data.confirmColor || 'primary'"
    (click)="confirm()"
    [disabled]="data.remarksRequired && !remarks.trim()"
  >
    {{ data.confirmText || 'Confirm' }}
  </button>
</mat-dialog-actions>
